import * as React from "react";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import axios from "axios";
import { responseNotification } from "../../utils/notify";
import { ImageUploader, SubmitResetBtn } from "../common";
import BreadCrumb from "../Layouts/Breadcrumb";
import moment from "moment";

export default function PersonalDetails() {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const navigate = useNavigate();
  const [gender, setGender] = useState<any>("MALE");
  const [accountCreatedBy, setAccountCreatedBy] = useState<any>("FOUNDER");
  const [singleMerchantInfo, setSingleMerchantInfo] = useState<any>({
    loading: false,
    data: null,
  });
  const [error, setError] = useState("");
  const [identificationType, setIdentificationType] = useState<any>("NID");

  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [startUpload3, setStartUpload3] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();

  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [identificationDocumentUrl, setIdentificationDocumentUrl] =
    useState<string>();
  const [identificationDocumentUrl2, setIdentificationDocumentUrl2] =
    useState<string>();
  const [utilityImage, setUtilityImage] = useState<string>();

  const [loading, setLoading] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [form] = Form.useForm();

  const fetchMerchantDetails = useCallback(() => {
    try {
      setSingleMerchantInfo({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/details`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setSingleMerchantInfo({
              loading: false,
              data: data?.data?.merchant,
            });
            setGeneratedImgUrl(
              data?.data?.merchant?.merchantPersonalDetail?.profilePicture
            );
          } else {
            setSingleMerchantInfo({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setSingleMerchantInfo({ loading: false, data: null });
          console.log(err);
        });
    } catch (error) {
      setSingleMerchantInfo({ loading: false, data: null });
      console.log(error, "error");
    }
  }, [token]);

  useEffect(() => {
    fetchMerchantDetails();
  }, [fetchMerchantDetails, token]);

  useEffect(() => {
    if (
      startUpload === "Uploaded" &&
      startUpload2 === "Uploaded" &&
      startUpload3 === "Uploaded"
    ) {
      form?.submit();
    }
  }, [startUpload, startUpload2, startUpload3]);

  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      fullName: data.name,
      gender: gender,
      email: data.email,
      dateOfBirth: data.dob,
      identificationDocumentType: identificationType,
      identificationDocumentNumber: data.identificationDocumentNumber,
      identificationDocumentUrl: identificationDocumentUrl,
      identificationDocumentUrl2: identificationDocumentUrl2,
      profilePicture: generatedImgUrl,
    };
    await fetch(`${process.env.REACT_APP_RIDER_API}/merchant/personal-info`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification(data?.message, "success");
          form.resetFields();
          navigate("/merchant-profile");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const resetData = () => {
    form?.resetFields();
  };

  useEffect(() => {
    if (singleMerchantInfo?.data) {
      form.resetFields();
      setGeneratedImgUrl(
        singleMerchantInfo?.data?.merchantPersonalDetail?.profilePicture
      );
      setIdentificationDocumentUrl(
        singleMerchantInfo?.data?.merchantPersonalDetail
          ?.identificationDocumentUrl
      );
      setIdentificationDocumentUrl2(
        singleMerchantInfo?.data?.merchantPersonalDetail
          ?.identificationDocumentUrl2
      );
      setUtilityImage(
        singleMerchantInfo?.data?.merchantPersonalDetail?.utilityImage
      );

      setAccountCreatedBy(
        singleMerchantInfo?.data?.merchantPersonalDetail?.accountCreatedBy
      );
      form.setFieldsValue({
        dob: singleMerchantInfo?.data?.merchantPersonalDetail?.dateOfBirth
          ? moment(singleMerchantInfo?.data?.merchantPersonalDetail?.dateOfBirth)
          : null,
      });
    }
  }, [form, singleMerchantInfo?.data]);
  return (
    <div className="flex overflow-hidden flex-col bg-stone-50 pb-[740px] max-md:pb-24">
      <main className="flex flex-col self-center mt-5 max-w-full w-[60%]">
        <BreadCrumb
          title="Personal Details & ID"
          className="flex gap-2 bg-red-700 text-base font-bold text-zinc-800"
        />

        <Form
          name="control-hooks"
          onFinish={onSubmit}
          form={form}
          layout="vertical"
          className="flex flex-col items-start pt-8 pr-20 pb-12 pl-8 mt-2.5 w-full bg-white rounded-md shadow-sm max-md:px-5 max-md:max-w-full"
          initialValues={{
            ...singleMerchantInfo?.data?.merchantPersonalDetail,
            name: singleMerchantInfo?.data?.fullName || "",
            email:
              singleMerchantInfo?.data?.merchantPersonalDetail?.email || "",
            //dob: singleMerchantInfo?.data?.dateOfBirth ? moment(singleMerchantInfo?.data?.dateOfBirth) : null,
          }}
        >
          {/* <div className="flex flex-wrap gap-8 mt-7">
            <Form.Item label="Account Create by">
              <Radio.Group
                onChange={(e) => setAccountCreatedBy(e.target.value)}
                defaultValue={accountCreatedBy}
              >
                <Radio value="FOUNDER">Founder</Radio>
                <Radio value="SELLER_MANAGER">Seller manager</Radio>
                <Radio value="SELLER_EMPLOYEE">Seller Employee</Radio>
                <Radio value="AGENT">Referral/Agent</Radio>
              </Radio.Group>
            </Form.Item>
          </div> */}
          <div className="flex flex-col gap-2 w-full">
            <Form.Item
              name="name"
              hasFeedback
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Name is Required!",
                },
              ]}
            >
              <Input
                type="text"
                id="name"
                placeholder="Enter name"
                className="px-4 py-3.5 font-medium bg-white rounded border border-solid border-neutral-300 text-neutral-300 w-[570px]"
              />
            </Form.Item>
          </div>
          {/* <div className="flex flex-col gap-2">
            <Form.Item
              name="designation"
              hasFeedback
              label="Designation"
              rules={[
                {
                  required: true,
                  message: "Designation is Required!",
                },
              ]}
            >
              <Input
                type="text"
                id="designation"
                placeholder="Enter Designation"
                className="px-4 py-3.5 font-medium bg-white rounded border border-solid border-neutral-300 text-neutral-300 w-[570px]"
              />
            </Form.Item>
          </div> */}
          <div className="flex flex-col gap-2">
            <Form.Item
              name="email"
              hasFeedback
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Email is Required!",
                },
              ]}
            >
              <Input
                type="text"
                id="email"
                placeholder="Enter Email"
                className="px-4 py-3.5 font-medium bg-white rounded border border-solid border-neutral-300 text-neutral-300 w-[570px]"
              />
            </Form.Item>
          </div>

          <Row gutter={24}>
            <Col span={12}> 
              <Form.Item
                hasFeedback
                label="Date Of Birth"
                name="dob"
                rules={[
                  {
                    required: true,
                    message: "Date of Birth is required!",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Select Date of Birth"
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  disabledDate={(current) => current && current > new Date()}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                hasFeedback
                label="Select Gender"
                name="gender"
                rules={[
                  {
                    required: true,
                    message: "Gender is Required!",
                  },
                ]}
              >
                <Select
                  placeholder="Gender"
                  options={[
                    { label: "Male", value: "MALE" },
                    { label: "Female", value: "FEMALE" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-3 gap-4">
              <div className="basis-0">
                <Form.Item
                  name="identificationDocumentType"
                  hasFeedback
                  label="Verify Identification "
                  initialValue={identificationType}
                  rules={[
                    {
                      required: true,
                      message: "Document Type is Required!",
                    },
                  ]}
                >
                  <Select
                    //defaultValue={identificationType}
                    onChange={(val) => setIdentificationType(val)}
                    options={[
                      {
                        label: "NID",
                        value: "NID",
                      },
                      {
                        label: "PASSPORT",
                        value: "PASSPORT",
                      },
                      {
                        label: "BIRTH CERTIFICATE",
                        value: "BIRTH_CERTIFICATE",
                      },
                    ]}
                  ></Select>
                </Form.Item>
              </div>

              <div className="basis-0">
                <Form.Item
                  name="identificationDocumentNumber"
                  hasFeedback
                  label={`${identificationType.replace("_", " ")} Number`}
                  rules={[
                    {
                      required: false,
                      message: "Number is Required!",
                    },
                  ]}
                >
                  <Input
                    id="identificationDocumentNumber"
                    type="text"
                    className="input-box"
                    placeholder="Enter Id Number"
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-4 gap-4">
              <div className="basis-0 pr-2 pb-4">
                <span className="text-md font-bold">Front Image</span>
                <ImageUploader
                  // crop={6.4}
                  imgUrl={identificationDocumentUrl || ""}
                  startUpload={startUpload2}
                  setStartUpload={(val: any) => setStartUpload2(val)}
                  setGeneratedImgUrl={(url: any) =>
                    setIdentificationDocumentUrl(url)
                  }
                />
              </div>
              {identificationType !== "BIRTH_CERTIFICATE" && (
                <>
                  <div className="basis-0">
                    <span className="text-md font-bold">Back Image</span>
                    <ImageUploader
                      // crop={6.4}
                      imgUrl={identificationDocumentUrl2 || ""}
                      startUpload={startUpload3}
                      setStartUpload={(val: any) => setStartUpload3(val)}
                      setGeneratedImgUrl={(url: any) =>
                        setIdentificationDocumentUrl2(url)
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-4 gap-4">
              <div className="basis-0 pr-2">
                <Form.Item
                  label="Profile Picture"
                  name="profilePicture"
                  rules={[
                    {
                      required: true,
                      message: "Profile picture is required!",
                    },
                  ]}
                >
                  <ImageUploader
                    imgUrl={generatedImgUrl || ""}
                    startUpload={startUpload}
                    setStartUpload={(val: any) => setStartUpload(val)}
                    setGeneratedImgUrl={(url: any) => {
                      setGeneratedImgUrl(url);
                      form.setFieldsValue({ profilePicture: url }); // form value সেট করা
                    }}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          <SubmitResetBtn
            onClickSubmit={(e) => {
              e.preventDefault();
              setStartUpload("Uploading");
              setStartUpload2("Uploading");
              setStartUpload3("Uploading");
            }}
            onClickReset={resetData}
            disabled={
              loading ||
              startUpload === "Uploading" ||
              startUpload2 === "Uploading" ||
              !!error
            }
            loading={
              loading ||
              startUpload === "Uploading" ||
              startUpload2 === "Uploading" ||
              !!error
            }
          />
        </Form>
      </main>
    </div>
  );
}
